export default {
  primary: {
    backgroundColor: 'transparent',
    color: 'dark',
    border: 'solid 2px',
    borderColor: 'dark',
    borderRadius: '0px',
    textTransform: 'uppercase',
    fontFamily: 'body',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['1rem', '', '1.1rem'],
    padding: '1rem 2rem',
    transition: 'all ease-in-out 0.5s',
    margin: '0rem',
    fontWeight: 'normal',
    width: 'fit-content',
    ':hover': {
      backgroundColor: 'dark',
      color: 'primary',
      borderColor: 'dark'
    }
  },
  secondary: {
    color: 'primary',
    border: 'solid 2px',
    borderColor: 'primary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    transition: 'all ease-in-out 0.5s',
    ':hover': {
      backgroundColor: 'secondary',
      color: 'white',
      borderColor: 'white'
    }
  },

  navButton: {
    padding: '0.5rem',
    color: 'white',
    backgroundColor: 'primary',
    borderRadius: '100px'
  }
}
